import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetTransferApproveLinkComponent } from './asset-transfer-approve-link/asset-transfer-approve-link.component';
import { AssetTransferApproveLandingPageComponent } from './asset-transfer-approve-landing-page/asset-transfer-approve-landing-page.component';

const routes: Routes = [
  {
    path: '', component: AssetTransferApproveLinkComponent,
    children: [
      { path: 'assetTransferApprovaList', component: AssetTransferApproveLandingPageComponent }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AssetTransferApproveRoutingModule { }
